/* eslint no-unused-vars: 'off' */
import $ from 'jquery'

export default {
    getCheckboxValue: function (name) {
        return document.getElementById(name).checked
    },
    clearSelectedItem: function (id) {
        this.getActiveListItem(id).removeClass('active')
    },
    clearSelectList: function (selection, id) {
        var value = '0'
        selection[id] = value

        var $li = this.getActiveListItem(id)
        $li.removeClass('active')
        var $list = $li.parent()

        this.setAndScroll($list, value)
    },
    setAndScroll: function ($list, value) {
        var $selected = $list.find('a[data-value="' + value + '"]')
        if ($selected.length > 0) {
            $selected.addClass('active')
            var optionTop = $selected.offset().top
            var selectTop = $list.offset().top
            $list.scrollTop($list.scrollTop() + (optionTop - selectTop))
        }
    },
    getSelectedValue: function (name) {
        var $activeLi = this.getActiveListItem(name)
        if ($activeLi.length > 0) {
            var value = $activeLi.data('value')
            if (value !== null && value !== '' && value !== 0)
                return value
        }
        return '0'
    },
    getActiveListItem: function (id) {
        return $('div#' + id + ' a.active')
    },
    setAndScrollSelectList: function (selection, id) {
        this.clearSelectedItem(id)

        var $list = $('#' + id)

        if (selection[id] === null || selection[id] === '' || $list.find('a[data-value="' + selection[id] + '"]').length === 0) {
            var unselectedValue = '0'
            selection[id] = unselectedValue
        }

        this.setAndScroll($list, selection[id])
    },
    focusLocation: {},
    initialize: function () {
        var vm = this
        $(document)
            .on('click', '.list-group-radio a', function (e) {
                e.preventDefault()
                var $selected = $(this)
                //Active has changed
                $selected.parent().find('a').removeClass('active')
                $selected.addClass('active')
            })
            .on('keydown', '.list-group-radio', function (e) {
                var theKey = e.which
                var $selected = $(this)
                var id = $selected.prop('id')
                var currentIndex = vm.focusLocation[id] !== undefined ? focusLocation[id] : $selected.find('.active').index()
                var $children = $selected.find('a')

                if (theKey === 13) { // the enter theKey code
                    e.preventDefault()
                    $children[currentIndex].click()
                }

                if (theKey === 40 || theKey === 38) {
                    //down arrow
                    e.preventDefault()

                    var nextIndex = 0
                    if (theKey === 40) {
                        //down arrow
                        nextIndex = (currentIndex + 1) < $children.length ? currentIndex + 1 : currentIndex

                    } else { // up arrow
                        nextIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex
                    }
                    vm.focusLocation[id] = nextIndex
                    $children[nextIndex].focus()
                }
            })
    }
}
